import { DialogContent, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";
import pluralize from "pluralize";

import { caseHistoryStatusLabels } from "../constants";
import { type CaseHistoryData } from "../types";
import { CaseHistoryDetailsVisitList } from "./VisitList";

interface CaseHistoryDetailsContentProps {
  caseHistoryData: CaseHistoryData;
}

export function CaseHistoryDetailsContent(props: CaseHistoryDetailsContentProps) {
  const { caseHistoryData } = props;
  const visitCount = caseHistoryData.attributes.visits?.length ?? 0;

  return (
    <DialogContent>
      <Stack alignItems="center" spacing={5} sx={{ height: "100%" }}>
        <Text variant="h3">
          {caseHistoryData.attributes.patient.attributes.externalPatientIdentifier}
        </Text>
        <Text variant="body2">
          {visitCount}{" "}
          {caseHistoryStatusLabels[caseHistoryData.attributes.status].toLocaleLowerCase()}{" "}
          {pluralize("visit", visitCount)}
        </Text>

        <CaseHistoryDetailsVisitList visits={caseHistoryData.attributes.visits} />
      </Stack>
    </DialogContent>
  );
}
